// src/components/ServiceFormModal.js

import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const ServiceFormModal = ({ isOpen, onClose, onSave, serviceToEdit }) => {
  const [hizmetAdi, setHizmetAdi] = useState('');
  const [fiyat, setFiyat] = useState('');
  const [aciklama, setAciklama] = useState('');
  const [tip, setTip] = useState(''); // Hizmet tipini tutacak state

  const serviceTypes = ['Bakım', 'Onarım', 'Kalibrasyon', 'Yazılım', 'Diğer']; // GÜNCELLENDİ

  useEffect(() => {
    if (isOpen && serviceToEdit) {
      setHizmetAdi(serviceToEdit.hizmetAdi);
      setFiyat(serviceToEdit.fiyat);
      setAciklama(serviceToEdit.aciklama || '');
      setTip(serviceToEdit.tip || ''); // Mevcut hizmetin tipini yükle
    } else {
      setHizmetAdi(''); setFiyat(''); setAciklama(''); setTip('');
    }
  }, [serviceToEdit, isOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!hizmetAdi || !fiyat || !tip) { // Tip seçimini zorunlu yap
      alert('Hizmet Adı, Fiyat ve Hizmet Tipi alanları zorunludur.');
      return;
    }
    const serviceData = { hizmetAdi, fiyat: Number(fiyat), aciklama, tip };
    onSave(serviceData);
    onClose();
  };

  if (!isOpen) return null;
  const isEditing = !!serviceToEdit;

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{isEditing ? 'Hizmeti Düzenle' : 'Yeni Hizmet Ekle'}</DialogTitle>
      <DialogContent>
        <Box component="form" noValidate autoComplete="off" sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          
          {/* Hizmet Tipi Seçim Kutusu */}
          <FormControl fullWidth required>
            <InputLabel id="service-type-label">Hizmet Tipi</InputLabel>
            <Select
              labelId="service-type-label"
              value={tip}
              label="Hizmet Tipi"
              onChange={(e) => setTip(e.target.value)}
            >
              {serviceTypes.map(type => (
                <MenuItem key={type} value={type}>{type}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField label="Hizmet Adı" value={hizmetAdi} onChange={(e) => setHizmetAdi(e.target.value)} fullWidth required />
          <TextField label="Fiyat (₺)" type="number" value={fiyat} onChange={(e) => setFiyat(e.target.value)} fullWidth required />
          <TextField label="Açıklama" value={aciklama} onChange={(e) => setAciklama(e.target.value)} multiline rows={3} fullWidth />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: '16px 24px' }}>
        <Button onClick={onClose}>İptal</Button>
        <Button onClick={handleSubmit} variant="contained">{isEditing ? 'Güncelle' : 'Kaydet'}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ServiceFormModal;